import React from 'react';

interface ExpandProps {
  size?: number;
  className?: string;
}

const Expand: React.FC<ExpandProps> = ({ size = 24, className }) => {
  return (
    <svg width={size} height={size} className={className} viewBox="0 96 960 960">
      <path d="M480 711L240 471l43-43 197 198 197-197 43 43-240 239z"></path>
    </svg>
  );
};

export default Expand;
